var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoResultFound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 122,
    height: 105.998,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 15589",
    fill: "#c3cbd7",
    d: "M0 0h121.787v91.995H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 15588",
    fill: "#c3cbd7",
    d: "M0 0h121.787v91.995H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 15585",
    transform: "translate(38 85.353)",
    fill: "#c3cbd7",
    d: "M0 0h18v4H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 15586",
    transform: "translate(0 8.353)",
    fill: "#c3cbd7",
    d: "M0 0h18v18H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 15586",
    fill: "#c3cbd7",
    d: "M0 0h9.336v9.336H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 15587",
    transform: "translate(38.138 19.853)",
    fill: "#c3cbd7",
    d: "M0 0h35.955v14.487H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 31959",
    transform: "translate(-736 -321.002)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 5461",
    cx: 61,
    cy: 15,
    rx: 61,
    ry: 15,
    transform: "translate(736 397)",
    fill: "#e8eaee"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 31957"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 31956",
    clipPath: "url(#a)",
    transform: "translate(736 321.002)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 31955"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 31954",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20688",
    d: "M56 72.853a32.5 32.5 0 1 1 32.5-32.5 32.537 32.537 0 0 1-32.5 32.5m0-58a25.5 25.5 0 1 0 25.5 25.5 25.529 25.529 0 0 0-25.5-25.5",
    fill: "#c3cbd7"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20689",
    d: "M106.643 92a3.491 3.491 0 0 1-2.475-1.025L75.883 62.684a3.5 3.5 0 1 1 4.949-4.949l28.286 28.285a3.5 3.5 0 0 1-2.475 5.98",
    fill: "#c3cbd7"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20690",
    d: "M92.483 12.25a10.6 10.6 0 0 1 1.787-5.641 13.767 13.767 0 0 1 5.216-4.733 16.418 16.418 0 0 1 8-1.876 17.088 17.088 0 0 1 7.5 1.568 12.176 12.176 0 0 1 5.025 4.264 10.459 10.459 0 0 1 1.773 5.861 9.06 9.06 0 0 1-1.011 4.366 13.341 13.341 0 0 1-2.4 3.238q-1.392 1.363-5 4.587a20.034 20.034 0 0 0-1.6 1.6 6.448 6.448 0 0 0-.894 1.26 6.156 6.156 0 0 0-.455 1.143q-.161.57-.483 2.007a3.261 3.261 0 0 1-3.487 3.047 3.562 3.562 0 0 1-2.564-1 3.912 3.912 0 0 1-1.041-2.96 10.4 10.4 0 0 1 2.784-7.428 46.054 46.054 0 0 1 3.4-3.238q1.875-1.641 2.711-2.476a8.428 8.428 0 0 0 1.406-1.861 4.5 4.5 0 0 0 .571-2.228 5.181 5.181 0 0 0-1.736-3.95 6.368 6.368 0 0 0-4.5-1.611 6.226 6.226 0 0 0-4.748 1.626 12.965 12.965 0 0 0-2.578 4.791q-1 3.312-3.78 3.312a3.716 3.716 0 0 1-2.77-1.158 3.539 3.539 0 0 1-1.128-2.505m14.3 32.117a4.613 4.613 0 0 1-3.12-1.157 4.058 4.058 0 0 1-1.334-3.239 4.172 4.172 0 0 1 1.29-3.106 4.356 4.356 0 0 1 3.164-1.26 4.305 4.305 0 0 1 4.367 4.366 4.092 4.092 0 0 1-1.319 3.224 4.452 4.452 0 0 1-3.048 1.172",
    fill: "#c3cbd7"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 31947",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 31946"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 31945",
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20691",
    d: "M54 89.353H40a2 2 0 0 1 0-4h14a2 2 0 0 1 0 4",
    fill: "#c3cbd7"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 31950",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 31949"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 31948",
    clipPath: "url(#d)",
    fill: "#c3cbd7",
    transform: "rotate(45 9 17.352)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20692",
    d: "M16 19.353H2a2 2 0 0 1 0-4h14a2 2 0 0 1 0 4"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20693",
    d: "M9 26.353a2 2 0 0 1-2-2v-14a2 2 0 0 1 4 0v14a2 2 0 0 1-2 2"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 31960",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 31949"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 31948",
    clipPath: "url(#e)",
    fill: "#c3cbd7",
    transform: "rotate(90 10.251 59.978)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20692",
    d: "M8.3 5.706H1.037a1.038 1.038 0 1 1 0-2.075H8.3a1.038 1.038 0 0 1 0 2.075"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20693",
    d: "M4.668 9.336a1.038 1.038 0 0 1-1.037-1.037V1.037a1.038 1.038 0 1 1 2.075 0v7.262a1.038 1.038 0 0 1-1.037 1.037"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 31953",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 31952"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 31951",
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20694",
    d: "M40.137 34.34a2 2 0 0 1-1.815-2.84 20.007 20.007 0 0 1 35.5-1.653 2 2 0 0 1-3.463 2 16.008 16.008 0 0 0-28.406 1.321 2 2 0 0 1-1.818 1.165",
    fill: "#c3cbd7"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResultFound);
export default __webpack_public_path__ + "static/media/No_Result_Found.2d85bff0b6617583da2f07538ff40bca.svg";
export { ForwardRef as ReactComponent };